export default __webpack_public_path__ + "static/media/stimmex-festival-2026_sx tablet.de1794d4.png";